import copy from 'clipboard-copy';
import { useCallback } from 'react';

import { useAppDispatch } from 'src/hooks/useStore';
import { alertSnackbar } from 'src/store/ui/actions';

export const COPY_LINK_ERROR_MESSAGE = 'Failed to copy link';

export type CopyToClipboardMessages = {
  successMessage: string;
  errorMessage?: string;
};

/**
 * Copies text and reports the outcome in a toast, so every copy action in the
 * app confirms success and failure the same way. Resolves to whether the copy
 * succeeded so callers only run follow-up work after a real copy.
 */
export const useCopyToClipboard = () => {
  const dispatch = useAppDispatch();

  return useCallback(
    async (
      text: string,
      {
        successMessage,
        errorMessage = COPY_LINK_ERROR_MESSAGE,
      }: CopyToClipboardMessages,
    ): Promise<boolean> => {
      try {
        await copy(text);
      } catch {
        dispatch(alertSnackbar({ errorMessage }));
        return false;
      }
      dispatch(alertSnackbar({ successMessage }));
      return true;
    },
    [dispatch],
  );
};
